var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CompButton',{attrs:{"placeholder":"选择商品","format":"{0}个商品","viewBtn":_vm.multiple,"disabled":_vm.disabledBtn,"value":_vm.value.length},on:{"click":_vm.handleClickAdd,"remove":_vm.onRemove,"view":_vm.onViewItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }